exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-4[data-v-57d77a22] {\n  top: 1rem;\n}\n.left-4[data-v-57d77a22] {\n  left: 1rem;\n}\n.mt-0\\.5[data-v-57d77a22] {\n  margin-top: .125rem;\n}\n.w-0\\.5[data-v-57d77a22] {\n  width: .125rem;\n}\n.bg-gray-lighter[data-v-57d77a22] {\n  background-color: #d2d6dc;\n}\n.h-2\\.5[data-v-57d77a22] {\n  height: .625rem;\n}\n.w-2\\.5[data-v-57d77a22] {\n  width: .625rem;\n}\n.inset-0[data-v-57d77a22] {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.h-0\\.5[data-v-57d77a22] {\n  height: .125rem;\n}\n", ""]);

// exports
